import type { RefObject } from 'react';
import { forwardRef } from 'react';

import { useButton } from '@react-aria/button';

import type { AriaButtonProps } from '@react-aria/button';

export const Button = forwardRef<HTMLButtonElement, AriaButtonProps<'button'>>(
  (props, ref) => {
    const { children } = props;
    const { buttonProps } = useButton(
      props,
      ref as RefObject<HTMLButtonElement>
    );
    return (
      <button {...buttonProps} ref={ref}>
        {children}
      </button>
    );
  }
);

Button.displayName = 'ComboBoxButton';
